<div class="event-info">
  <div class="header" *ngIf="!singleMode">
    <div class="menu">
      <span (click)="openBottomSheet()">
        <mat-icon>menu</mat-icon>
      </span>
    </div>
    <div class="share-settings-icons">
      <div class="icons-sm">
        <span class="icon-sm" (click)="showDailyView()" [ngClass]="{ active: showDaily }" *ngIf="authenticated && zone.id">
          <mat-icon>bar_chart</mat-icon>
        </span>
        <span class="icon-sm share-icon" (click)="copyLink()" *ngIf="authenticated && !singleMode">
          <mat-icon>share</mat-icon>
        </span>
      </div>
      <div class="copy-link" *ngIf="copyItem">
        <span style="border: 1px solid rgba(238, 238, 238, 0.2)">
          <span class="link">{{ capacityDashboardUrl }}</span>
          <span class="copy" (click)="copyUrl()">Copy</span>
        </span>
      </div>
      <div class="confirm-link" *ngIf="isSuccess">
        <span class="text"> Copied to clipboard </span>
      </div>
    </div>
  </div>
  <div class="settings-icon" *ngIf="authenticated && !singleMode">
    <div class="share-content" *ngIf="copyItem">
      <div class="copy-link">
        <span style="border: 1px solid rgba(238, 238, 238, 0.2)">
          <span class="link">{{ capacityDashboardUrl }}</span>
          <span class="copy" (click)="copyUrl()">Copy</span>
        </span>
      </div>
      <div class="confirm-link" *ngIf="isSuccess">
        <span class="text"> Copied to clipboard </span>
      </div>
    </div>
    <div class="icon share-icon" (click)="copyLink()">
      <mat-icon>share</mat-icon>
    </div>
    <div class="icon statistics settings-icon" (click)="showDailyView()" [ngClass]="{ active: showDaily }" *ngIf="zone.id">
      <mat-icon>bar_chart</mat-icon>
    </div>
  </div>
  <div class="mb-0">
    <div class="d-flex flex-column cover-logo-wrapper">
      <div class="logo-box-wrapper" *ngIf="event.logo">
        <div class="logo-box" [ngClass]="{ 'with-image': event.logo, 'no-cover': !event.cover_page }">
          <div class="image-display" *ngIf="event.logo">
            <img [src]="event.logo" alt="event logo" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="info" [ngClass]="{ 'no-cover': !event.cover_page }">
    <div class="details" [ngClass]="{ 'no-logo': !event.logo }">
      <span class="name">{{ event.name }}</span>
    </div>
    <div class="capacity-name">
      <span>{{ zone?.name || 'All Sub Zones' }}</span>
    </div>
  </div>
</div>
